import type { JSX } from 'react';

import { useTrackView } from 'src/app/shared/hooks/tracking';

import { PetitionContent } from './components/PetitionContent';
import { PetitionData } from './components/PetitionData';

export function EditForm(): JSX.Element {
	useTrackView('petition_edit_view');

	return (
		<>
			<PetitionContent />
			<PetitionData />
		</>
	);
}
